import { useUiConfigVersions } from 'api/uiConfig/uiConfig.api'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import uiConfigStore from 'store/uiConfig/uiConfig'
import { dynamicClassName } from 'styles/helper'

import { useSnapshot } from 'valtio'

import UiConfigBadge from 'views/UiConfigView/components/UiConfigBadge/UiConfigBadge'

import styles from './UiConfigVersions.module.less'

export default function UiConfigVersions(): ReactElement {
  const snap = useSnapshot(uiConfigStore)
  const { t } = useTranslation()
  const uid = snap.editingUid
  const id = snap.editingId

  useUiConfigVersions(uid)

  if (!uid || !id) {
    return <></>
  }

  const versionUids = snap.versions[id] || []
  const uiConfigs = versionUids.map((versionUid) => snap.uiConfigs[versionUid])

  function selectUiConfigVersion(uiConfig: UiConfig): void {
    if (typeof uiConfig.uid !== 'number') {
      return
    }

    uiConfigStore.setEditingUid(uiConfig.uid, {
      confirmDiscardDraft: () => window.confirm(t('Discard unsaved draft and switch to selected config?')),
    })
  }

  return (
    <div className={styles.UiConfigVersions}>
      {uiConfigs.map((uiConfig) => (
        <div
          key={uiConfig.uid}
          className={dynamicClassName({
            [styles.UiConfigVersions_Item]: true,
            [styles.UiConfigVersions_Item__active]: uiConfig.uid === snap.editingUid,
          })}
          onClick={() => selectUiConfigVersion(uiConfig)}
        >
          {`(${uiConfig.id}.${uiConfig.version}) ${uiConfig.component}`}

          <UiConfigBadge uiConfig={uiConfig} />
        </div>
      ))}
    </div>
  )
}
